import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { dataTableInjectionKey as M } from "../interface.js";
import w from "./FilterMenu.js";
import y from "./RenderFilter.js";
import V from "../../../_mixins/use-config.js";
import x from "../../../_internal/icon/src/Icon.js";
import I from "../../../_internal/icons/Filter.js";
import S from "../../../popover/src/Popover.js";
import { defineComponent as T, inject as O, computed as u, h as n } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as j } from "../../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
function k(t, r, a) {
  const o = Object.assign({}, t);
  return o[r] = a, o;
}
const z = T({
  name: "DataTableFilterButton",
  props: {
    column: {
      type: Object,
      required: !0
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    const {
      mergedComponentPropsRef: r
    } = V(), {
      mergedThemeRef: a,
      mergedClsPrefixRef: o,
      mergedFilterStateRef: i,
      filterMenuCssVarsRef: s,
      paginationBehaviorOnFilterRef: h,
      doUpdatePage: p,
      doUpdateFilters: v,
      filterIconPopoverPropsRef: g
    } = O(M), f = j(!1), d = i, c = u(() => t.column.filterMultiple !== !1), m = u(() => {
      const e = d.value[t.column.key];
      if (e === void 0) {
        const {
          value: l
        } = c;
        return l ? [] : null;
      }
      return e;
    }), F = u(() => {
      const {
        value: e
      } = m;
      return Array.isArray(e) ? e.length > 0 : e !== null;
    }), P = u(() => {
      var e, l;
      return ((l = (e = r == null ? void 0 : r.value) === null || e === void 0 ? void 0 : e.DataTable) === null || l === void 0 ? void 0 : l.renderFilter) || t.column.renderFilter;
    });
    function C(e) {
      const l = k(d.value, t.column.key, e);
      v(l, t.column), h.value === "first" && p(1);
    }
    function R() {
      f.value = !1;
    }
    function b() {
      f.value = !1;
    }
    return {
      mergedTheme: a,
      mergedClsPrefix: o,
      active: F,
      showPopover: f,
      mergedRenderFilter: P,
      filterIconPopoverProps: g,
      filterMultiple: c,
      mergedFilterValue: m,
      filterMenuCssVars: s,
      handleFilterChange: C,
      handleFilterMenuConfirm: b,
      handleFilterMenuCancel: R
    };
  },
  render() {
    const {
      mergedTheme: t,
      mergedClsPrefix: r,
      handleFilterMenuCancel: a,
      filterIconPopoverProps: o
    } = this;
    return n(S, Object.assign({
      show: this.showPopover,
      onUpdateShow: (i) => this.showPopover = i,
      trigger: "click",
      theme: t.peers.Popover,
      themeOverrides: t.peerOverrides.Popover,
      placement: "bottom"
    }, o, {
      style: {
        padding: 0
      }
    }), {
      trigger: () => {
        const {
          mergedRenderFilter: i
        } = this;
        if (i)
          return n(y, {
            "data-data-table-filter": !0,
            render: i,
            active: this.active,
            show: this.showPopover
          });
        const {
          renderFilterIcon: s
        } = this.column;
        return n("div", {
          "data-data-table-filter": !0,
          class: [`${r}-data-table-filter`, {
            [`${r}-data-table-filter--active`]: this.active,
            [`${r}-data-table-filter--show`]: this.showPopover
          }]
        }, s ? s({
          active: this.active,
          show: this.showPopover
        }) : n(x, {
          clsPrefix: r
        }, {
          default: () => n(I, null)
        }));
      },
      default: () => {
        const {
          renderFilterMenu: i
        } = this.column;
        return i ? i({
          hide: a
        }) : n(w, {
          style: this.filterMenuCssVars,
          radioGroupName: String(this.column.key),
          multiple: this.filterMultiple,
          value: this.mergedFilterValue,
          options: this.options,
          column: this.column,
          onChange: this.handleFilterChange,
          onClear: this.handleFilterMenuCancel,
          onConfirm: this.handleFilterMenuConfirm
        });
      }
    });
  }
});
export {
  z as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/data-table/src/HeaderButton/FilterButton.js
// module id = 1645
// module chunks = 67